import { render, staticRenderFns } from "./sellerReviews.vue?vue&type=template&id=7a859ad4"
import script from "./sellerReviews.vue?vue&type=script&lang=js"
export * from "./sellerReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports